import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import isEmpty from "lodash/isEmpty";
import useProductName from "brand-customization/useProductName";
import { DocumentTitle, PageHeader, Spinner } from "components/common";
import { useStore } from "stores/connect";
import ForwarderDocs from "forwarder/util/ForwarderDocs";
import LicenseCheck from "license/LicenseCheck";
import { LICENSE_SUBJECTS } from "license/constants";
import ForwardersListComponent from "./forwarders/ForwardersListComponent";
import InputProfilesStore, { InputProfilesActions } from "./stores/InputProfilesStore";
import EmptyForwarderListComponent from "./forwarders/EmptyForwarderListComponent";
import ForwardersContext from "./forwarders/ForwardersContext";
import PaginatedForwarderListProvider from "./forwarders/PaginatedForwarderListProvider";
import withIsPermitted from "./util/withIsPermitted";
import ForwarderPageNavigation from "./ForwarderPageNavigation";
const REQUIRED_PERMISSIONS = ["forwarders:read", "inputprofiles:read"];
const ForwardersPage = () => {
  const { t } = useTranslation("enterprise_forwarder");
  const productName = useProductName();
  const { all: inputProfiles } = useStore(InputProfilesStore);
  useEffect(() => {
    InputProfilesActions.listAll();
  }, []);
  return /* @__PURE__ */ React.createElement(DocumentTitle, { title: t("forwarders_page.title") }, /* @__PURE__ */ React.createElement(ForwarderPageNavigation, null), /* @__PURE__ */ React.createElement(
    PageHeader,
    {
      title: t("forwarders_page.title"),
      documentationLink: {
        title: t("common.forwarder_documentation"),
        path: ForwarderDocs.FORWARDER
      }
    },
    /* @__PURE__ */ React.createElement("span", null, t("forwarders_page.description", { productName }))
  ), /* @__PURE__ */ React.createElement(
    LicenseCheck,
    {
      licenseSubject: LICENSE_SUBJECTS.forwarder,
      displayWarningContainer: true,
      featureName: "Forwarder",
      bsStyle: "danger"
    }
  ), /* @__PURE__ */ React.createElement(PaginatedForwarderListProvider, null, /* @__PURE__ */ React.createElement(ForwardersContext.Consumer, null, ({ forwarders, pagination, changeQuery, changeSort, changeStateFilter, isLoading }) => {
    if (forwarders && inputProfiles && pagination) {
      return forwarders.length === 0 && isEmpty(pagination == null ? void 0 : pagination.query) && (pagination == null ? void 0 : pagination.stateFilter) === "any" ? /* @__PURE__ */ React.createElement(EmptyForwarderListComponent, null) : /* @__PURE__ */ React.createElement(
        ForwardersListComponent,
        {
          forwarders,
          isLoading,
          inputProfiles,
          pagination,
          onQueryChange: changeQuery,
          onSortChange: changeSort,
          onStateFilterChange: changeStateFilter
        }
      );
    }
    return /* @__PURE__ */ React.createElement(Spinner, null);
  })));
};
export default withIsPermitted(ForwardersPage, REQUIRED_PERMISSIONS);
